import React, { Component } from 'react';
import {connect} from 'react-redux';
const ESCAPE_KEY = 27;

class AgentHeaderSearch extends Component {
	constructor(props) {
    super(props);
    this.state = {
      searchString: '',
    };
  }

  handleSearch = (e) => {
    this.setState({
      searchString: e.target.value
    }, () => {
      this.props.handleAgentSearch(this.state.searchString);
    });
  }

	render() {
    const {
			searchString
    } = this.state;
		const {
			translations,
			selectedLanguage,
		} = this.props;
		return (
      <div className="navbar-form navbar-right hidden-xs hidden-sm pos-r" style={{marginRight: 'calc(50% - 250px)'}}>
        <div className="form-group">
          <div className="input-with-icon w-full">
            <input
              type="text"
							value={ searchString }
              className={`form-control${this.props.theme} input-smm${this.props.theme} navbar-autocomplete`}
              placeholder={ translations.search[selectedLanguage] }
              onChange={ this.handleSearch }
            />
            <span className="icon icon-magnifying-glass" />
          </div>
        </div>
      </div>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				agentInfo: state.agentInfo,
				addressBook: state.addressBook,
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        theme: state.common.theme
    };
}

export default connect(mapStateToProps)(AgentHeaderSearch);



// WEBPACK FOOTER //
// ./src/agent/AgentHeaderSearch.js